import { createStore, applyMiddleware, compose } from "redux";
import { persistStore } from "redux-persist";
import createSagaMiddleware from "redux-saga";

import reducers, { init_state } from "../ducks";

import rootSagas from "./sagas";

const sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware];

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

//STORE
let store = createStore(
  reducers,
  init_state,
  composeEnhancers(applyMiddleware(...middleware))
);

sagaMiddleware.run(rootSagas);

export const persistor = persistStore(store);
export default store;
